// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-e3cebb98] .ant-steps-item-content {\n  min-height: 80px;\n}", ""]);
// Exports
module.exports = exports;
